<template>
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_3523_13357)">
            <path
                d="M6.47428 17.5V15.8333C6.47428 14.9493 6.82547 14.1014 7.45059 13.4763C8.07572 12.8512 8.92356 12.5 9.80762 12.5H16.4743C17.3583 12.5 18.2062 12.8512 18.8313 13.4763C19.4564 14.1014 19.8076 14.9493 19.8076 15.8333V17.5"
                stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path
                d="M13.1403 9.16667C11.2994 9.16667 9.80697 7.67428 9.80697 5.83333C9.80697 3.99238 11.2994 2.5 13.1403 2.5C14.9812 2.5 16.4736 3.99238 16.4736 5.83333C16.4736 7.67428 14.9812 9.16667 13.1403 9.16667Z"
                stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path
                d="M1.47363 17.5V15.8333C1.47418 15.0948 1.72 14.3773 2.17249 13.7936C2.62499 13.2099 3.25852 12.793 3.97363 12.6083"
                stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path
                d="M7.30762 2.60834C6.5906 2.79192 5.95509 3.20892 5.50125 3.7936C5.04742 4.37827 4.80108 5.09736 4.80108 5.8375C4.80108 6.57765 5.04742 7.29674 5.50125 7.88141C5.95509 8.46609 6.5906 8.88309 7.30762 9.06667"
                stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_3523_13357">
                <rect width="20" height="20" fill="white" transform="matrix(-1 0 0 1 20.6406 0)" />
            </clipPath>
        </defs>
    </svg>

</template>